import React, { useEffect, useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { useApolloClient, useQuery } from '@apollo/client';
import PrivateRoute from './PrivateRoute';
import RedirectSSO from './RedirectSSO';
import Login from './Login';
import Navbar from './layout/Navbar';
import Logout from './Logout';
import Home from './Home';
import Categories from './Categories';
import CategoryAdd from './CategoryAdd';
import CategoryEdit from './CategoryEdit';
import Users from './Users';
import UserAdd from './UserAdd';
import UserEdit from './UserEdit';
import Footer from './layout/Footer';
import { GET_TOKEN, REFRESH_TOKEN } from '../gql/auth';
import Loading from './layout/Loading';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
}));

const Pages = () => {
  const [loading, setLoading] = useState(true);
  const { data } = useQuery(GET_TOKEN);
  const client = useApolloClient();
  const classes = useStyles();
  useEffect(() => {
    const getRefreshToken = async () => {
      try {
        await client.mutate({
          mutation: REFRESH_TOKEN,
          variables: { init: true },
          update: (cache, { data: { refreshToken } }) => {
            cache.writeQuery({
              query: GET_TOKEN,
              data: {
                token: refreshToken.token,
                netId: refreshToken.me.netId,
                role: refreshToken.me.role,
                loading: false,
                isLoggedIn: true,
              },
            });
          },
        });
      } catch (error) {
        client.writeQuery({ query: GET_TOKEN, data: { loading: false } });
        throw error;
      }
    };
    getRefreshToken();
  }, []);

  useEffect(() => {
    if (data.loading === false) {
      setLoading(false);
    }
  }, [data]);

  if (loading) return <Loading />;

  return (
    <div className={classes.root}>
      <CssBaseline />
      <div style={{ display: 'flex' }}>
        <Switch>
          <Route
            exact
            path={['/login', '/redirectSSO', '/logout', '/test']}
            component={() => {
              return null;
            }}
          />
          <Route path={['/']} component={Navbar} />
        </Switch>
        <Switch>
          <Route exact path="/logout" component={Logout} />
          <Route exact path="/redirectSSO" component={RedirectSSO} />
          <Route exact path="/login" component={Login} />
          <PrivateRoute
            exact
            path="/categories"
            component={Categories}
            adminOnly
          />
          <PrivateRoute
            exact
            path="/categories/add"
            component={CategoryAdd}
            adminOnly
          />
          <PrivateRoute
            exact
            path="/categories/:id"
            component={CategoryEdit}
            adminOnly
          />
          <PrivateRoute exact path="/users" component={Users} adminOnly />
          <PrivateRoute exact path="/users/add" component={UserAdd} adminOnly />
          <PrivateRoute
            exact
            path="/users/:id"
            component={UserEdit}
            adminOnly
          />
          <PrivateRoute exact path="/" component={Home} />
        </Switch>
      </div>
      <Footer />
    </div>
  );
};

export default Pages;
